import GLightbox from 'glightbox';

/**
 * File lightbox.js
 * Adds lightbox to WordPress gallery blocks.
 */

const lightbox = GLightbox({
    selector: 'data-glightbox'
});

document.querySelectorAll('.wp-block-gallery img').forEach(function(image) {

    let src = image.getAttribute("src");
    if (image.hasAttribute("srcset")) {
        const srcset = image.getAttribute("srcset").split(", ");
        if (srcset.length > 0) src = srcset[srcset.length - 1].split(" ")[0];
    }

    const href = document.createElement("a");
    href.setAttribute("href", src);
    href.setAttribute("data-glightbox", 'type: image');

    image.parentNode.insertBefore(href, image);
    href.appendChild(image);
});

lightbox.reload();